export function createGroupFields (fields) {
  let arr = []
  // fields = cloneDeep(arr)

  // const isGroup = item => item.hasOwnProperty('groupLabel')
  fields.forEach(item => {
    const groupLabel = item.groupLabel || '默认'
    const findItem = arr.find(v => v.label === groupLabel)
    item.key = item.propertyName
    if (findItem) {
      findItem.fields.push(item)
    } else {
      arr.push({
        key: groupLabel,
        label: groupLabel,
        fields: [item], // 分组所有字段
        rowFields: [], // 页面实际展示字段
        show: true,
        $show: true, // 个性设置按钮状态
        showExpandIcon: false,
        $expand: true, // 个性设置折叠状态
        expand: false // 展开收起状态
      })
    }
  })
  arr.forEach(item => {
    item.show = !item.fields.every(v => !v.show)
    item.$show = !!item.show
  })
  return arr
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/query-form-group/utils.js